'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
var prd = exports.prd = {
  merchantConfigUrl: 'https://merchant-config.commerce.cimpress.io',
  fulfillerIdentityUrl: 'https://fulfilleridentity.trdlnk.cimpress.io',
  customizrUrl: 'https://customizr.at.cimpress.io'
};

var int = exports.int = {
  merchantConfigUrl: 'https://int-merchant-config.commerce.cimpress.io',
  fulfillerIdentityUrl: 'https://fulfilleridentity.trdlnk.cimpress.io',
  customizrUrl: 'https://customizr.at.cimpress.io'
};
//# sourceMappingURL=endpoints.js.map


//////////////////
// WEBPACK FOOTER
// ./node_modules/@cimpress-technology/react-platform-tenant-selector/lib/services/endpoints.js
// module id = 567
// module chunks = 0